/**
 * @generated SignedSource<<be009befd11709ea456627c7ca4e887d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type UrlMappingPreviewPanel_Query$variables = {
  url: string;
  siteSlug: string;
  ref?: string | null;
  title?: string | null;
  envName?: string | null;
  includeInactive?: boolean | null;
  at?: string | null;
};
export type UrlMappingPreviewPanel_QueryVariables = UrlMappingPreviewPanel_Query$variables;
export type UrlMappingPreviewPanel_Query$data = {
  readonly resolveUrlMapping: {
    readonly inputUrl: string;
    readonly mappedUrl: string;
    readonly matched: boolean;
    readonly matchedRuleName: string | null;
    readonly matchedMatchType: UrlMappingMatchType | null;
    readonly matchedRuleActive: boolean | null;
  };
};
export type UrlMappingPreviewPanel_QueryResponse = UrlMappingPreviewPanel_Query$data;
export type UrlMappingPreviewPanel_Query = {
  variables: UrlMappingPreviewPanel_QueryVariables;
  response: UrlMappingPreviewPanel_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "at"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "envName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeInactive"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ref"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteSlug"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "url"
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "at",
        "variableName": "at"
      },
      {
        "kind": "Variable",
        "name": "envName",
        "variableName": "envName"
      },
      {
        "kind": "Variable",
        "name": "includeInactive",
        "variableName": "includeInactive"
      },
      {
        "kind": "Variable",
        "name": "ref",
        "variableName": "ref"
      },
      {
        "kind": "Variable",
        "name": "siteSlug",
        "variableName": "siteSlug"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      },
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "ResolveUrlMappingResult",
    "kind": "LinkedField",
    "name": "resolveUrlMapping",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inputUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mappedUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "matched",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "matchedRuleName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "matchedMatchType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "matchedRuleActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingPreviewPanel_Query",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UrlMappingPreviewPanel_Query",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "96b9624330eb4289f50a478dec70cb2b",
    "id": null,
    "metadata": {},
    "name": "UrlMappingPreviewPanel_Query",
    "operationKind": "query",
    "text": "query UrlMappingPreviewPanel_Query(\n  $url: String!\n  $siteSlug: String!\n  $ref: String\n  $title: String\n  $envName: String\n  $includeInactive: Boolean\n  $at: ISO8601DateTime\n) {\n  resolveUrlMapping(url: $url, siteSlug: $siteSlug, ref: $ref, title: $title, envName: $envName, includeInactive: $includeInactive, at: $at) {\n    inputUrl\n    mappedUrl\n    matched\n    matchedRuleName\n    matchedMatchType\n    matchedRuleActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "42cc723f53a49679686d6a004b835071";

export default node;
